import { PropsWithChildren } from 'react';

export type Props = PropsWithChildren<{
  onSubmit: () => void;
  testId?: string;
  id?: string;
}>;

export const Form = ({ onSubmit, children, testId, id }: Props): JSX.Element => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} data-testid={testId} id={id}>
      {children}
    </form>
  );
};
